export interface WeatherResult {
  inputLatitude: number;
  inputLongitude: number;
  hour: Date | null;
  temperature: number;
  windSpeed: number;
  humidity: number;
  latitude: number;
  longitude: number;
  station: string;
}

export interface AirPollutionResult {
  hour: Date | null;
  pm25: number;
  ozone: number;
}

export enum AirPollutionNetwork {
  airNow = 'AirNow',
  purpleAir = 'PurpleAir'
}

export interface CustomInfiltrationResult {
  inputLatitude: number;
  inputLongitude: number;
  hour: Date;
  outdoorLatitude: number;
  outdoorLongitude: number;
  outdoorSingleSensor: boolean;
  outdoorPM25: number;
  outdoorTemperature: number;
  indoorLatitude: number;
  indoorLongitude: number;
  indoorSingleSensor: boolean;
  indoorPM25: number;
  indoorTemperature: number;
  infiltrationFactor: number;
  indoorConcentration: number;
  infiltrationFactorAverage: number;
}

export interface PurpleAirMonitorResult {
  id: number;
  label: string;
  latitude: number;
  longitude: number;
  inside: boolean;
  single: boolean;
}

export interface Location {
  latitude: number;
  longitude: number;
}
